import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down-circle",
  "use": "icon-arrow-down-circle-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-arrow-down-circle\"><style>#icon-arrow-down-circle .st0{fill:#2a2a2a}</style><path class=\"st0\" d=\"M19.1 10.1C19.1 5.1 15 1 10 1s-9 4.1-9 9.1 4.1 9.1 9.1 9.1 9-4.1 9-9.1z\" /><path class=\"st0\" d=\"M19.1 10C19.1 5 15 .9 10 .9S.9 5 .9 10 5 19.1 10 19.1s9.1-4.1 9.1-9.1z\" /><path d=\"M20 10c0-5.5-4.5-10-10-10S0 4.5 0 10s4.5 10 10 10 10-4.5 10-10zm-5.3-1.3l-4.6 4.7-4.8-4.7 1.4-1.4 3.4 3.3 3.2-3.3 1.4 1.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol